import { useTranslation } from 'react-i18next';

export default function CtaSection() {
  const { t } = useTranslation('about');

  return (
    <section className="w-full bg-white py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-5xl mx-auto">
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-ink-800 to-ink-900 px-6 md:px-14 py-12 md:py-16 text-center">
            <div
              className="absolute inset-0 opacity-[0.06]"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
                backgroundSize: '36px 36px',
              }}
            />
            <div className="relative">
              <span className="text-xs font-semibold text-warm-400 uppercase tracking-[0.2em] mb-3 block">
                {t('cta.label')}
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
                {t('cta.title')}
              </h2>
              <p className="text-sm md:text-base text-white/60 max-w-xl mx-auto mb-8 leading-relaxed">
                {t('cta.subtitle')}
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="/get-quote"
                  className="w-full sm:w-auto px-6 py-3 bg-warm-500 text-white text-sm font-semibold rounded-md hover:bg-warm-600 transition-colors whitespace-nowrap"
                >
                  {t('cta.quote')}
                </a>
                <a
                  href="/contact"
                  className="w-full sm:w-auto px-6 py-3 border border-white/20 text-white text-sm font-semibold rounded-md hover:bg-white/10 transition-colors whitespace-nowrap"
                >
                  {t('cta.contact')}
                </a>
                <a
                  href="/packaging"
                  className="w-full sm:w-auto px-6 py-3 text-white/70 text-sm font-medium rounded-md hover:text-white transition-colors whitespace-nowrap"
                >
                  {t('cta.browse')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}